import {
  Card,
  CardContent,
  Grid,
  Paper,
  CardActionArea,
  Typography,
  makeStyles,
  Box,
  Select,
  MenuItem,
  ButtonGroup,
  Button,
} from "@material-ui/core";
import { useAuthenticated, useSetLocale, useTranslate } from "react-admin";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";

import paymentLogo from "../../assets/icons/payment.png";
import biLogo from "../../assets/icons/bi.png";
import ciLogo from "../../assets/icons/ci.png";
import theme from "../../theme";
import settings, {
  loadLocale,
  saveLocale,
  changeBranch,
} from "../../utils/settings";

//import { havePermission } from "../../utils/settings";

const useButtonBoxStyles = makeStyles((theme) => ({
  normalContainer: {
    backgroundColor: theme.orange,
    display: "grid",
    gridTemplateRows: "140px auto",
    placeItems: "center",
  },
  boxContainer: {
    backgroundColor: theme.orange,
    width: 267,
    height: 245,
    borderRadius: 21,
    boxShadow: "0px 8px 12px rgba(0, 0, 0, 0.25)",
  },
  caption: {
    textAlign: "center",
    width: "100%",
    alignSelf: "start",
    color: theme.white,
    fontSize: 28,
    fontWeight: 500,
    lineHeight: 1.2,
  },
}));

const ButtonBox = ({ link, text, icon, disabled }) => {
  const classes = useButtonBoxStyles();
  const history = useHistory();
  const handleClick = () => {
    let path = link;
    history.push(path);
  };
  return (
    <Card className={classes.boxContainer}>
      <CardActionArea onClick={handleClick} disabled={disabled}>
        <CardContent
          style={{ height: 224 }}
          className={classes.normalContainer}
        >
          <img
            src={icon}
            alt="icon"
            style={{
              width: 102,
              height: 102,
              pointerEvents: "none",
              objectFit: "contain",
              paddingBlockEnd: "20px",
              paddingBlockStart: "20px",
            }}
          />

          <Typography variant="h6" className={classes.caption}>
            {text}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

const ButtonBoxGrid = (props) => {
  return (
    <Grid
      item
      xs={12}
      sm={4}
      style={{ display: "grid", justifyContent: "center" }}
    >
      <ButtonBox {...props} />
    </Grid>
  );
};

const useMainMenuStyles = makeStyles((theme) => {
  return {
    allContainer: {
      marginTop: 15,
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: "flex",
      justifyContent: "center",
      backgroundColor: theme.white,
    },
    container: {
      position: "relative",
      boxSizing: "border-box",
      top: 0,
      bottom: 0,
      display: "grid",
      gridTemplateRows: "126px 101px auto",
      alignItems: "center",
      borderRadius: 0,
      boxShadow: "none",
    },
    content: {
      width: "100%",
      paddingLeft: 20,
      paddingRight: 20,
      marginLeft: 10,
      boxSizing: "border-box",
      display: "grid",
      minHeight: 80,
    },
    selectEmpty: {
      width: "352px",
      height: "49px",
    },
  };
});
const MainMenu = () => {
  const mainMenuclasses = useMainMenuStyles();
  const translate = useTranslate();
  const { branches, branchId } = settings();
  const classes = useMainMenuStyles();
  const [selectedBranch] = useState(branchId);
  useAuthenticated();

  return (
    <ThemeProvider theme={theme}>
      <Box className={mainMenuclasses.allContainer}>
        <Paper className={mainMenuclasses.container}>
          <LocaleSwitcher />

          <Box className={classes.content}>
            {haveBranchSelection(branches) && (
              <>
                <Typography style={{ fontSize: 20 }}>
                  {translate("ra.text.selectBranch")}
                </Typography>
                <Select
                  value={selectedBranch}
                  onChange={(event) => {
                    changeBranch(
                      event.target.value,
                      branches.find(
                        (branch) => branch.id === event.target.value
                      ).name
                    );
                    return window.location.reload();
                  }}
                  displayEmpty
                  className={classes.selectEmpty}
                  inputProps={{ "aria-label": "Without label" }}
                  variant="outlined"
                >
                  {branches.map((branch) => {
                    return <MenuItem value={branch.id}>{branch.name}</MenuItem>;
                  })}
                </Select>
              </>
            )}
          </Box>

          <Box
            style={{
              display: "grid",
              placeItems: "center",

              height: "100%",
            }}
          >
            <Grid
              container
              spacing={2}
              style={{
                height: "100%",
                paddingTop: 45,
                paddingLeft: 30,
                paddingRight: 30,
                boxSizing: "border-box",
                display: "grid",
                justifyItems: "center",
                gridTemplateColumns: "33% 34% 33%",
                gridAutoRows: "auto",
              }}
            >
              <ButtonBoxGrid
                link={"payment"}
                text={translate("ra.text.paymentTitle")}
                icon={paymentLogo}
              />

              <ButtonBoxGrid
                link={"ci"}
                text={translate("ra.text.ciTitle")}
                icon={ciLogo}
              />
              <ButtonBoxGrid
                link={"bi"}
                text={translate("ra.text.biTitle")}
                icon={biLogo}
              />

              {/* <ButtonBoxGrid
              disabled
              link={"campaign"}
              text="Campaign"
              icon={campaignLogo}
            />
            <ButtonBoxGrid
              disabled
              link={"calendar"}
              text="Calendar"
              icon={calendarLogo}
            />
            <ButtonBoxGrid
              disabled
              link={"order"}
              text="Orders"
              icon={orderLogo}
            /> */}
            </Grid>
          </Box>
        </Paper>
      </Box>
    </ThemeProvider>
  );
};

const useSwitchStyles = makeStyles((theme) => ({
  langSwitchContainer: {
    display: "grid",
    paddingRight: 20,
    boxSizing: "border-box",
  },
  switchGrid: {
    justifyContent: "flex-end",
  },
  langButton: {
    backgroundColor: "#ffff",
    color: "#FA9917",
    border: "1px solid #fa9917",
    borderRadius: "6px",
    height: "25px",
    fontWeight: "bold",
  },
  langButtonActive: {
    backgroundColor: "#FA9917",
    color: "#ffff",
    border: "1px solid #fa9917",
    borderRadius: "6px",
    height: "25px",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#FA9917",
      color: "#ffff",
    },
  },
}));

const haveBranchSelection = (branches) => {
  if (branches?.length > 1) {
    return true;
  } else return false;
};

const LocaleSwitcher = () => {
  //const locale = useLocale();
  const [langTH, setLangTH] = useState();
  const setLocale = useSetLocale();
  const classes = useSwitchStyles();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const [locale, error] = loadLocale();

    if (locale === "th" || error) {
      setLangTH(true);
    } else {
      setLangTH(false);
    }
    setLoading(false);
    return;
  }, []);

  const handleChange = (lang) => {
    setLangTH(lang === "th");
    setLocale(lang);
    saveLocale(lang);
  };
  if (loading) return null;

  return (
    <Box className={classes.langSwitchContainer}>
      <Grid
        component="label"
        container
        className={classes.switchGrid}
        spacing={1}
      >
        <ButtonGroup>
          <Button
            className={!langTH ? classes.langButtonActive : classes.langButton}
            onClick={() => handleChange("en")}
          >
            Eng
          </Button>
          <Button
            className={langTH ? classes.langButtonActive : classes.langButton}
            onClick={() => handleChange("th")}
          >
            Thai
          </Button>
        </ButtonGroup>
      </Grid>
    </Box>
  );
};
// return (
//   <Box className={classes.langSwitchContainer}>
//     <Grid
//       component="label"
//       container
//       className={classes.switchGrid}
//       spacing={1}
//     >
//       <Grid item>
//         <Typography>English</Typography>
//       </Grid>
//       <Grid item>
//         <AntSwitch checked={langTH} onChange={handleChange} name="checkedC" />
//       </Grid>
//       <Grid item>
//         <Typography>Thai</Typography>
//       </Grid>
//     </Grid>
//   </Box>
// );

// return (
//   <div>
//     <div>Language</div>
//     <Button disabled={locale === "th"} onClick={() => setLocale("th")}>
//       English
//     </Button>
//     <Button disabled={locale === "en"} onClick={() => setLocale("en")}>
//       Thai
//     </Button>
//   </div>
// );

// const AntSwitch = withStyles((theme) => ({
//   root: {
//     width: 28,
//     height: 16,
//     padding: 0,
//     marginTop: 3,
//     borderRadius: 16,
//     display: "flex",
//     alignItems: "center",
//   },
//   switchBase: {
//     padding: 2,

//     boxSizing: "border-box",
//     color: theme.palette.common.white,
//     "&$checked": {
//       transform: "translateX(12px)",
//       color: theme.palette.common.white,
//       "& + $track": {
//         opacity: 1,
//         backgroundColor: theme.palette.primary.main,
//         borderColor: theme.palette.primary.main,
//       },
//     },
//   },
//   thumb: {
//     width: 12,
//     height: 12,
//     boxShadow: "none",
//   },
//   track: {
//     border: `1px solid ${theme.palette.grey[500]}`,
//     // borderRadius: 16,
//     opacity: 1,
//     backgroundColor: theme.palette.grey[500],
//   },

//   checked: {},
// }))(Switch);

export default MainMenu;
